const InlinePhotoStrip = ({ 
  images, 
  bgColor = '#2a1e18', 
  itemWidth = 'calc(33vw - 1.5rem)', 
  itemAspect = '3 / 4', 
  gap = '1rem', 
  padding = '1.5rem',
  altPrefix = 'Image de la retraite COCON SACRÉ'
}) => {
  const doubled = [...images, ...images];
  const duration = Math.max(images.length * 3, 15);

  return (
    <div style={{ overflow: 'hidden', backgroundColor: bgColor }}>
      <style>{`
        @keyframes strip-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
      <div
        style={{
          display: 'flex',
          gap,
          padding,
          width: 'max-content',
          animation: `strip-scroll ${duration}s linear infinite`,
        }}
      >
        {doubled.map((item, i) => (
          <div
            key={i}
            style={{
              flex: 'none',
              width: itemWidth,
              aspectRatio: itemAspect,
              borderRadius: gap === '0' ? '0' : '1rem',
              overflow: 'hidden',
            }}
          >
            <img
              src={typeof item === 'string' ? item : item.src}
              alt={typeof item === 'object' && item.alt ? item.alt : `${altPrefix} ${Math.floor(i / 2) + 1}`}
              loading="lazy"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InlinePhotoStrip;
